import React from 'react';
import { get } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ButtonStandardCompact from 'components/atoms/buttons/compact/Primary';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import FieldValue from 'components/atoms/text/FieldValue';
import AssociatedBrandNameLink from 'containers/forms/users/AssociatedBrandNameLink';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { USER_ALTER_CAP_GROUPS, USER_BRAND_ASSOCIATE, USER_ORGANIZATION_BRANDING_CODE_EDIT } from 'constants/capabilities';

const OrganizationBrandingCodeProtectedComponent = ProtectedComponent({
    requiredCapabilities: [USER_ORGANIZATION_BRANDING_CODE_EDIT]
})(props => (<React.Fragment>{props.children}</React.Fragment>));

const CapabilityGroupsProtectedComponent = ProtectedComponent({
    requiredCapabilities: [USER_ALTER_CAP_GROUPS]
})(props => (<React.Fragment>{props.children}</React.Fragment>));

const AssociatedBrandField = ProtectedComponent({
    requiredCapabilities: [USER_BRAND_ASSOCIATE]
})(props => <React.Fragment>
    {props.brandId ? (
        <Row>
            <Col md={6}>
                <FormSectionHeading>Associated Brand</FormSectionHeading>

                <AssociatedBrandNameLink brandId={props.brandId}/>
            </Col>
        </Row>
    ) : null }
</React.Fragment>);

const ViewUser = (props) => {
    const userId = get(props, 'user.id', null);
    const firstName = get(props, 'user.firstName', '');
    const lastName = get(props, 'user.lastName', '');
    const email = get(props, 'user.email', '');
    const organizationBrandingCode = get(props, 'user.meta.organizationBrandingCode', null);
    const entities = get(props, 'user.Entities', []);
    const capGroups = get(props, 'user.CapabilityGroups', []);
    const brandId = get(props, 'user.brandId', null);

    return (
        <Row>
            <Col md={6}>
                <Row>
                    <Col md={3}>
                        <FormSectionHeading>First Name</FormSectionHeading>
                        <FieldValue>{firstName}</FieldValue>
                    </Col>
                    <Col direction="right" md={3}>
                        <FormSectionHeading>Last Name</FormSectionHeading>
                        <FieldValue>{lastName}</FieldValue>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <FormSectionHeading>Email</FormSectionHeading>
                        <FieldValue>{email}</FieldValue>
                    </Col>
                </Row>

                {organizationBrandingCode ? (
                    <OrganizationBrandingCodeProtectedComponent>
                        <Row>
                            <Col md={6}>
                                <FormSectionHeading>Organization Branding</FormSectionHeading>
                                <FieldValue>{organizationBrandingCode}</FieldValue>
                            </Col>
                        </Row>
                    </OrganizationBrandingCodeProtectedComponent>
                ) : null}

                <Row>
                    <Col md={6}>
                        <FormSectionHeading>Entity Access</FormSectionHeading>
                        {entities.length === 0 &&
                            <FieldValue>No Entities Assigned</FieldValue>}

                        {entities.map(parent => (
                            <Link to={`/admin/entities/${parent.id}`} target="_blank" title="Go to capability group">
                                <FieldValue>{parent.name}</FieldValue>
                            </Link>
                        ))}
                    </Col>
                </Row>

                <CapabilityGroupsProtectedComponent>
                    <FormSectionHeading>Capability Groups</FormSectionHeading>

                    {capGroups.length === 0 &&
                        <FieldValue>No Capability Groups</FieldValue>}

                    {capGroups.map(parent => (
                        <Link to={`/admin/capability-groups/${parent.id}`} target="_blank" title="Go to capability group">
                            <FieldValue>{parent.name}</FieldValue>
                        </Link>
                    ))}
                </CapabilityGroupsProtectedComponent>

                <AssociatedBrandField brandId={brandId} />

                <Row>
                    <Col xs={6}>
                        <ButtonStandardCompact
                            margin="40px 0px 0px 0px"
                            type="submit"
                            onClick={() => props.push(`/admin/users/${userId}/edit`)}>
                            Edit
                        </ButtonStandardCompact>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

ViewUser.propTypes = {
    user: PropTypes.object,
    push: PropTypes.func
};

export default ViewUser;



// WEBPACK FOOTER //
// ./src/components/organisms/user/ViewUser.js